import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import RegistrationForm from './components/RegistrationForm';
import ThankYou from './components/ThankYou';
import './styles.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#f50057',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  // Add responsive breakpoints that prioritize mobile first
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    // Make buttons more touch-friendly on mobile
    MuiButton: {
      styleOverrides: {
        root: {
          padding: '12px 16px',
          fontSize: '1rem',
        },
      },
    },
    // Increase form control sizes for better touch targets
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginBottom: '16px',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: '1.1rem',
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Container maxWidth="sm">
          <Box sx={{ 
            my: { xs: 2, sm: 3 }, 
            textAlign: 'center',
            px: { xs: 1, sm: 2 }
          }}>
            <Typography 
              variant="h4" 
              component="h1" 
              gutterBottom
              sx={{ 
                fontSize: { xs: '1.75rem', sm: '2.125rem' },
                fontWeight: 'bold'
              }}
            >
              WONCA South Asia Region Conference 2025
            </Typography>
            <Typography 
              variant="h5" 
              component="h2" 
              gutterBottom 
              color="text.secondary"
              sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' } }}
            >
              Onsite Registration
            </Typography>
            <Typography 
              variant="body1" 
              color="text.secondary"
              sx={{ mb: 2 }}
            >
              April 4-6, 2025
            </Typography>
          </Box>
          <Routes>
            <Route path="/" element={<RegistrationForm onsiteOnly={true} />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Routes>
          
          {/* Footer with SPRDH logo */}
          <Box 
            sx={{ 
              mt: 4, 
              mb: 2, 
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Powered by
            </Typography>
            <Box 
              component="img"
              src="https://sprdh.com/wp-content/uploads/2023/08/sprdh-logo-1.png"
              alt="SPRDH Logo"
              sx={{ 
                maxWidth: '120px',
                height: 'auto'
              }}
            />
          </Box>
        </Container>
      </Router>
    </ThemeProvider>
  );
}

export default App; 